/* global yotpoWidgetsContainer */

import { AnalyticsController, AnalyticsService } from '../services/analytics/types'

export const isContainerDefined = (): boolean => {
  // @ts-ignore
  return typeof (yotpoWidgetsContainer) !== 'undefined'
}

export const registerToContainer = (name: string, constructor: Function): void => {
  // @ts-ignore
  yotpoWidgetsContainer[name] = constructor
}

export const initWidgets = () => {
  // @ts-ignore
  yotpoWidgetsContainer.initWidgets()
}

export const initAnalytics = (analyticsController: AnalyticsController): AnalyticsService => {
  // @ts-ignore
  return new yotpoWidgetsContainer.Analytics(analyticsController)
}
export const isAnalyticsDefined = (): boolean => {
  // @ts-ignore
  return isContainerDefined() && !!yotpoWidgetsContainer.Analytics
}
